<template>
  <div
    v-if="course.rigid_pricing_rules"
    class="mt-3"
  >
    <label for="quantity">
      <small>{{ 'Licence quantity' | translate }}</small>
    </label>
    <select class="form-select mb-3" v-model="quantity">
      <option
        v-for="priceItem in course.price_list"
        :key="priceItem.id"
        :value="priceItem.activatesAfter"
      >
        {{ priceItem.activatesAfter }}
      </option>
    </select>
  </div>
  <div v-else class="mt-3">
    <label for="quantity">
      <small>{{ 'Licence quantity' | translate }}</small>
    </label>
    <input
      name="quantity"
      min="1"
      max="9999"
      step="1"
      type="number"
      class="form-control"
      v-model="quantity"
    />
  </div>
</template>

<script>
export default {
  computed: {
    quantity: {
      get() {
        return this.$store.state.quantity
      },
      set(value) {
        if (value < 1) {
          value = 1
        }

        this.$store.commit('updateQuantity', value)
      },
    },
    course() {
      return this.$store.state.course
    },
  },
}
</script>
